import { RibbonBar, RibbonSection } from 'common/components';
import { useHistory } from 'react-router-dom';
import {
  OtherLayout
} from 'pages/home/ribbon/components';

const GREvalExportRibbon = () => {
  const history = useHistory();
  const goBack = () => {
    history.push('/gr/eval-forms');
  };
  return (
    <>
      <RibbonBar>
        <RibbonSection>

        </RibbonSection>
        <OtherLayout
          ribbonSide='right'
          ribbonType='evalFormExport'
          isHaveAddOpenItem={false}
          closeDetailCallback={goBack}
        />
      </RibbonBar>

    </>
  );

};


export default GREvalExportRibbon;
